import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';

@Component({
  selector: 'jfriedman-ai-qa',
  templateUrl: './aiqa.component.html',
  styleUrls: ['aiqa.component.scss']
})
export class JFriedmanAiQaComponent implements OnInit, OnDestroy {
  public question = '';
  public busy = false;
  public error = '';
  public messages: { role: 'user' | 'assistant', text: string }[] = [];

  constructor(
    private http: HttpClient,
    private router: Router,
    private authSvc: AuthorizeService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    const elm = this.document.getElementById('nav-menu');
    if (elm) this.renderer.addClass(elm, 'hideme');
    const elm2 = this.document.getElementById('app-footer');
    if (elm2) this.renderer.addClass(elm2, 'hideme');
  }

  public ngOnDestroy(): void {
    const elm = this.document.getElementById('nav-menu');
    if (elm) this.renderer.removeClass(elm, 'hideme');
    const elm2 = this.document.getElementById('app-footer');
    if (elm2) this.renderer.removeClass(elm2, 'hideme');
  }

  async ngOnInit(): Promise<void> {
    // Ensure user is authenticated and whitelisted (route also has AuthorizeGuard)
    const token = await this.authSvc.getToken();
    if (!token?.sub) {
      this.router.navigate(['/home']);
      return;
    }

    if (token.sub !== 'acfc2497-cb44-4394-b866-3f546b306ff6'
      && token.sub !== '75188666-0c61-4d26-b4d1-d184befa3afb' // Alec Lubin
      && token.sub !== 'e9665018-defb-45b4-a5d7-aff4e4c0ddcd' // jfriedman
      && token.sub !== '074e9283-ff17-49c1-b6f8-787d11dad581'
      && token.sub !== 'ff08b278-700d-4d51-a589-42034ab6c925' // Steve Cohn
      && token.sub !== 'be539c1c-553f-4b1f-bc4b-9575a5917f32' // Tom Simmons
    ) {
      this.router.navigate(['/home']);
      return;
    }
  }

  ask(): void {
    const q = (this.question || '').trim();
    if (!q) return;

    this.busy = true;
    this.error = '';
    this.messages.push({ role: 'user', text: q });
    this.question = '';

    this.http.post<any>('/ai/qa', { question: q }).subscribe(
      (resp) => {
        const text = resp?.outputText || '(no output)';
        this.messages.push({ role: 'assistant', text });
        this.busy = false;
      },
      (err) => {
        this.error = err?.error?.message || err?.message || 'Unknown error';
        this.busy = false;
      }
    );
  }
}

